export const classroomKeys = {
  all: ["classrooms"] as const,
  lists: () => [...classroomKeys.all, "list"] as const,
  list: (filter?: string) => [...classroomKeys.lists(), { filter }] as const,
  // PRD-45 — the /salones "Archivados" tab's fetch. Kept as its own key
  // (not folded into `lists()`) so switching tabs doesn't refetch the
  // active-only list every time.
  listIncludingArchived: () => [...classroomKeys.lists(), { includeArchived: true }] as const,
  details: () => [...classroomKeys.all, "detail"] as const,
  detail: (id: string) => [...classroomKeys.details(), id] as const,
  // PRD-61 §FR-3 — under `detail(id)`, so every mutation that already
  // invalidates `classroomKeys.all` (a grade saved, a material sent) refreshes
  // the per-cut averages too.
  results: (id: string) => [...classroomKeys.detail(id), "results"] as const,
  // PRD-66 — the materials some enrolled students have no copy of. Under
  // `detail(id)` for the same reason: a student added (roster mutations) or a
  // material generated/backfilled (material mutations) already invalidates
  // `classroomKeys.all`, so the roster notice refreshes with no new wiring.
  materialGaps: (id: string) => [...classroomKeys.detail(id), "material-gaps"] as const,
}

// PRD-37 / ADR-0031 — Subjects is a separate resource (school-scoped
// catalog) but has no pages of its own on this app, so it's co-located
// here rather than in its own top-level feature (per architecture.md).
export const subjectKeys = {
  all: ["subjects"] as const,
  lists: () => [...subjectKeys.all, "list"] as const,
}
